import { IOffer } from '../models';
import { getRelevantOffer } from './offers';

// converts flat list of episodes into seasons
export const generateSeasons = (
  series: any,
  episodes: any,
  checkForOffer: boolean = true
) => {
  const {
    title: seriesTitle,
    imageUrl,
    altIds: { tmsSeriesId: seriesId },
  } = series;
  const seasonMap: { OtherEpisodes?: any } = {};

  episodes.forEach((episode) => {
    const {
      seasonNum,
      offer,
    }: {
      seasonNum: number | string;
      offer: IOffer[];
    } = episode;

    // if checking for offer, skip episodes without offers
    if (checkForOffer && (!offer || !offer?.length)) {
      return;
    }

    // filter null episodes if offer check is enabled
    const currentOffer = getRelevantOffer(offer);

    if (checkForOffer && !currentOffer?.movieAssetId) {
      return;
    }

    // Normalize season number field based on different data sources

    const season = seasonMap[seasonNum || 'OtherEpisodes'];

    if (season) {
      // adds sorted season list to map
      seasonMap[seasonNum || 'OtherEpisodes'] = {
        ...season,
        episodes: [
          ...season.episodes,
          { ...episode, seriesId, seriesTitle, imageUrl },
        ].sort((a, b) => b.episodeNum - a.episodeNum),
      };

      if (seasonMap.OtherEpisodes) {
        seasonMap.OtherEpisodes.number = Object.keys(seasonMap).length;
      }
    } else {
      if (!seasonMap.OtherEpisodes && !seasonNum) {
        seasonMap.OtherEpisodes = {
          name: 'Other Episodes',
          number: 0,
          episodes: [{ ...episode, seriesId, seriesTitle, imageUrl }],
        };
      } else {
        // create new map entry and add episode to season
        seasonMap[seasonNum] = {
          name: `Season ${seasonNum}`,
          number: seasonNum,
          episodes: [{ ...episode, seriesId, seriesTitle, imageUrl }],
        };
      }
    }
  });

  // convert seasonMap to array of arrays in season order
  return [...Object.keys(seasonMap)]
    .sort((a, b) => {
      // Always put Other Episodes at the end of the list
      if (a === 'Other Episodes' || b === 'Other Episodes') {
        return -1;
      }

      // Order from highest to lowest season
      return parseInt(b, 10) - parseInt(a, 10);
    })
    .map((key) => seasonMap[key]);
};
